/**
 * Excel导出工具
 */

/**
 * 将数据导出为Excel文件
 * @param {Array} headers - 表头数组，例如: ['申请人', '部门', '邮箱']
 * @param {Array} data - 数据数组，每个元素是一个数组，对应一行数据
 * @param {String} filename - 文件名
 */
export function exportExcel (headers, data, filename = 'export.xlsx') {
  // 创建工作表数据
  const worksheet = [headers, ...data]

  // 转换为CSV格式（使用制表符分隔）
  const csvContent = worksheet.map(row => 
    row.map(cell => {
      // 处理包含逗号、换行符或引号的单元格
      const cellStr = String(cell || '')
      if (cellStr.includes(',') || cellStr.includes('\n') || cellStr.includes('"')) {
        return `"${cellStr.replace(/"/g, '""')}"`
      }
      return cellStr
    }).join(',')
  ).join('\n')

  // 添加BOM以支持中文
  const BOM = '\uFEFF'
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' })

  // 创建下载链接
  const link = document.createElement('a')
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', filename.replace('.xlsx', '.csv'))
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }
}

/**
 * 使用更好的Excel格式导出（使用xlsx格式）
 */
export function exportToExcel (headers, data, filename = 'export.xlsx') {
  // 使用HTML表格方式生成Excel
  let html = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">'
  html += '<head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>'
  html += '<x:Name>Sheet1</x:Name>'
  html += '<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>'
  html += '</x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->'
  html += '<meta charset="UTF-8">'
  html += '</head><body>'
  html += '<table>'
  
  // 添加表头
  html += '<thead><tr>'
  headers.forEach(header => {
    html += `<th style="background-color: #f0f0f0; font-weight: bold; border: 1px solid #ddd; padding: 8px;">${header}</th>`
  })
  html += '</tr></thead>'
  
  // 添加数据
  html += '<tbody>'
  data.forEach(row => {
    html += '<tr>'
    row.forEach(cell => {
      html += `<td style="border: 1px solid #ddd; padding: 8px;">${cell || ''}</td>`
    })
    html += '</tr>'
  })
  html += '</tbody></table></body></html>'

  // 创建Blob
  const blob = new Blob(['\ufeff' + html], {
    type: 'application/vnd.ms-excel;charset=utf-8;'
  })

  // 创建下载链接
  const link = document.createElement('a')
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }
}
